<template>
  <div class="view-space-page">
    <div v-if="loading" class="loading-wrap">加载中...</div>
    <div v-else-if="error" class="error-wrap">{{ error }}</div>
    <div v-else-if="space" class="scene-wrap">
      <SpaceSceneViewer
        v-if="space.sceneModelUrl"
        :scene-model-url="space.sceneModelUrl"
        :hotspots="space.hotspots || []"
        :published="!!space.published"
        :initial-camera="space.initialCamera"
        :move-speed="space.moveSpeed"
      />
      <SpaceEditor v-else :space-data="space" :edit-mode="false" />
      <div class="back-bar">
        <router-link to="/" class="back-link">← 返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import SpaceEditor from "@/components/SpaceEditor.vue";
import SpaceSceneViewer from "@/components/SpaceSceneViewer.vue";
import { getSpaceBySlug, getSpaceById } from "@/api/space";

const route = useRoute();
const slug = computed(() => route.params.slug);
const spaceId = computed(() => route.query.id);
const space = ref(null);
const loading = ref(true);
const error = ref("");

function parseHotspots(json) {
  if (!json) return [];
  try {
    const arr = typeof json === "string" ? JSON.parse(json) : json;
    return Array.isArray(arr) ? arr : [];
  } catch (_) {
    return [];
  }
}

const loadSpace = async () => {
  loading.value = true;
  error.value = "";
  try {
    let res;
    if (spaceId.value) {
      res = await getSpaceById(Number(spaceId.value));
    } else {
      res = await getSpaceBySlug(slug.value || "main-city");
    }
    if (res?.code === 200 && res?.data) {
      const d = res.data;
      let objects = [];
      try {
        const raw =
          typeof d.objectsJson === "string"
            ? JSON.parse(d.objectsJson || "[]")
            : d.objectsJson;
        objects = Array.isArray(raw) ? raw : raw?.objects || [];
      } catch (_) {
        /* ignore */
      }
      let initialCamera = null;
      let moveSpeed = 8;
      if (d.initialCameraJson) {
        try {
          const cam = JSON.parse(d.initialCameraJson);
          if (cam?.position && cam?.target) {
            initialCamera = { position: cam.position, target: cam.target };
            if (typeof cam.moveSpeed === "number" && cam.moveSpeed >= 1)
              moveSpeed = Math.min(30, cam.moveSpeed);
          }
        } catch (_) {
          /* ignore parse */
        }
      }
      space.value = {
        id: d.id,
        name: d.name,
        description: d.description,
        thumbnail: d.thumbnailUrl || d.thumbnail,
        thumbnailUrl: d.thumbnailUrl || d.thumbnail,
        template: d.template || "basic",
        objectsJson: d.objectsJson,
        objects,
        sceneModelUrl: d.sceneModelUrl || "",
        hotspots: parseHotspots(d.hotspotsJson),
        published: !!d.published,
        initialCamera,
        moveSpeed,
      };
    } else {
      error.value = res?.message || "空间不存在";
    }
  } catch (e) {
    error.value = "加载失败";
  } finally {
    loading.value = false;
  }
};

onMounted(loadSpace);
</script>

<style scoped>
.view-space-page {
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  background: #1a1a1a;
  overflow: hidden;
}
.loading-wrap,
.error-wrap {
  padding: 80px 20px;
  text-align: center;
  color: #fff;
}
.scene-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.back-bar {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 100;
}
.back-link {
  color: #fff;
  text-decoration: none;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}
.back-link:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
